import {useCallback, useState} from "react";
import {service} from "infrastructure";
import {isNullOrUndefined, isSuccessResponse} from "presentation/common";
import {toastHelper} from "presentation/common/helpers/toast";

export const useSignIn = () => {
  const [email, setEmail] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const onResetSignIn = useCallback(() => {
    setEmail(null);
  }, [setEmail]);


  const onSubmit = useCallback(async (values) => {
    try {
      setLoading(true);
      const response = await service.signIn(values.email);

      if (isSuccessResponse(response)) {
        setEmail(values.email);
        setLoading(false);
        return;
      }
    }
    catch (e) {
      setEmail(null);
      setLoading(false);
    }

    toastHelper.showGenericErrorMessage();
  }, [setEmail]);

  return {
    isSubmitting: !isNullOrUndefined(email),
    isLoading,
    onSubmit,
    email,
    onResetSignIn
  }
}
